import { PlusCircleIcon } from "@primer/octicons-react";
import { IconButton, SelectPanel, Tooltip } from "@primer/react";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiWrapper } from "../../api/apiWrapper";
import Text from "../../components/ui/text";
import { useCommonContext } from "../../contexts/common";
import { IFormEditor } from "../../models/response/form/IFormEditor";
import { RootState } from "../../state/reducers";
import { ePageBaseStatus } from "../../models/ePageBaseStatus";
import { actions } from "../../state/actions/actionsWrapper";

type TagBoxCauHoiCoSanProps = {
  isReadonly?: boolean;
  value?: number[];
  onValueChanged: (ids: number[], data?: IFormEditor[]) => void;
  className?: string;
  isShowClearButton?: boolean;
  preText?: string;
  stylingMode?: "outlined" | "filled" | "underlined";
  onAddNew?: () => void;
  width?: number;
  sx?: any
};
const TagBoxCauHoiCoSan = (props: TagBoxCauHoiCoSanProps) => {
  const { language } = useSelector((x: RootState) => x.common);
  const { status, crmSurveyFormQuestions, crmSurveyFormQuestionSelectedIds } = useSelector(
    (x: RootState) => x.crmSurvey.crmSurveyFormQuestion
  );
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("");
  const { translate } = useCommonContext();
  const dispatch = useDispatch();

  // useEffect(() => {
  //   handleReloadCauHoiCoSans();
  // }, []);
  // const handleReloadCauHoiCoSans = async () => {
  //   const res = await apiWrapper.formWrapper.formEditor.load();
  //   if (res.is_success) {
  //     setCauHoiCoSanViewModels(res.data.filter((x: any) => x.is_hethong));
  //   }
  // };


  useEffect(() => {
    if (status === ePageBaseStatus.is_not_initialization) {
      dispatch(actions.crmSurveyFormWrapper.crmSurveyFormQuestion.LOAD_START(''));
    }
  }, []);
  
  const dataSource = useMemo(() => {
    return crmSurveyFormQuestions.map((x) => ({
      id: x.id,
      text: x.title,
    }));
  }, [crmSurveyFormQuestions]);
  const filteredItems = useMemo(() => {
    return dataSource.filter((item) =>
      item.text?.toLowerCase().includes(filter.toLowerCase())
    );
  }, [dataSource, filter]);

  //nếu selected= obj -> chọn 1, = array -> chọn nhiều
  const selected = useMemo(() => {
    return dataSource.filter((x) => props.value?.includes(x.id));
  }, [dataSource, props.value]);
  const setSelected = (selecteds: any) => {
    if (selecteds) props.onValueChanged(selecteds.map((x: any) => x.id));
  };
  return (
    <SelectPanel
      renderAnchor={({
        children,
        "aria-labelledby": ariaLabelledBy,
        ...anchorProps
      }) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Text
            text="Chọn từ nguồn"
            sx={{
              color: "fg.muted", ...props.sx
            }}
          />
          <Tooltip aria-label="Chọn từ nguồn có sẵn" direction="n">
            <IconButton
              icon={PlusCircleIcon}
              variant="invisible"
              size="medium"
              aria-label="Câu hỏi có sẵn"
              {...anchorProps}
              onClick={(e) => {
                anchorProps.onClick?.(e);
              }}
            />
          </Tooltip>
        </div>
      )}
      title={""}
      placeholderText="Search"
      open={open}
      onOpenChange={setOpen}
      items={filteredItems}
      selected={selected}
      onSelectedChange={setSelected}
      onFilterChange={setFilter}
      showItemDividers={true}
      overlayProps={{ width: "xlarge", height: "medium" }}
    />

  );
};
export { TagBoxCauHoiCoSan };

